import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchProjectCreation from './SearchProjectCreation';
import InviteConsultant from './InviteConsultant';
import finalizeIcon from '../../../assets/images/finalize-icon.png';
import './EmployerInvitesConsultantToProjectModal.scss';

class EmployerInvitesConsultantToProjectModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 'invite',
      project: null,
      projects: null,
      projectResourceId: null,
    };

    this.handleInvited = this.handleInvited.bind(this);
    this.redirectToFeaturedPage = this.redirectToFeaturedPage.bind(this);
    this.redirectToProjectReview = this.redirectToProjectReview.bind(this);
    this.redirectToHopOnACall = this.redirectToHopOnACall.bind(this);
  }

  setCurrentPageToInvite() {
    this.setState({ currentPage: 'invite' });
  }

  setCurrentPageToQuestions() {
    this.setState({ currentPage: 'questions' });
  }

  handleInvited(projectResourceId) {
    this.setState({ currentPage: 'invite-more', projectResourceId });
  }

  redirectToFeaturedPage() {
    const { filters } = this.props;
    if (!filters) {
      window.location.href = '/featured';
    } else {
      const filteredFilters = Object.fromEntries(

        Object.entries(filters).filter(([_, value]) => value !== null),
      );
      // Construct the URLSearchParams
      const refinementList = new URLSearchParams();
      Object.entries(filteredFilters).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v, index) => {
            refinementList.append(`${key}[${index}]`, v);
          });
        } else {
          refinementList.append(key, value);
        }
      });
      window.location.href = `/featured?${refinementList.toString()}`;
    }
  }

  redirectToProjectReview() {
    const { projectResourceId } = this.state;
    window.location.href = `/projects/${projectResourceId}/edit`;
  }

  redirectToHopOnACall() {
    const { projectResourceId } = this.state;
    const { currentUser } = this.props;

    const queryParams = new URLSearchParams({
      firstname: currentUser.firstName,
      lastname: currentUser.lastName,
      email: currentUser.email,
      current_last_company_name__c: currentUser.companyName,
      sales_intake_description__c: `/projects/${projectResourceId}`,
    });

    const salesBookingLink = `https://clora.na.chilipiper.com/book/clora?${queryParams.toString()}`;
    window.open(salesBookingLink, '_blank');
  }

  renderPage() {
    const { currentPage, projects, project } = this.state;
    const {
      consultant,
      workLocationOptions,
      durationOptions,
      timePerWeekOptions,
      csrfToken,
      query,
      fromProject,
      filters,
    } = this.props;

    if (currentPage === 'invite-more') {
      return (
        <div className="invite-more">
          <div className="success-message">
            <div className="consultant-detail g-row--always">
              <span role="img" aria-labelledby="party popper" className="party-popper mr-20">
                &#127881;
              </span>
              <div className="consultant-detail">
                <h3>{`Congrats! Your proposal request has been sent to ${consultant.first_name}.`}</h3>
              </div>
            </div>
          </div>
          <div className="invite-more-message">
            <h1>Find the perfect talent even faster!</h1>
            <div className="message-body">
              <div className="g-row">
                <div className="left-side g-flex-25">
                  <img
                    src={finalizeIcon}
                    alt="talk to clora"
                  />
                </div>
                <div className="right-side g-flex-70">
                  <div>
                    Boost your visibility by finalizing your requirements now and
                    tap into our network of 11,000+ top-tier consultants.
                  </div>
                  <ul>
                    <li>Draw the right talent with a detailed description.</li>
                    <li>Expedite your search by letting consultants self-qualify.</li>
                    <li>Help us to pre-screen candidates to reduce noise.</li>
                  </ul>
                  <div>
                    <button
                      className="btn btn-primary"
                      onClick={this.redirectToProjectReview}
                    >
                      Finalize Project Requirements
                    </button>
                  </div>
                  <div className="continue-action">
                    <a
                      role="button"
                      onClick={this.redirectToFeaturedPage}
                      tabIndex={0}
                    >
                      Continue to browse
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="message-footer mb-4">
              <strong>Need a hand?</strong>
&nbsp;
              Our team is here to ensure you find your ideal consultant fast.
              You an use the chat below, or &nbsp;
              <a
                tabIndex={0}
                role="button"
                onClick={this.redirectToHopOnACall}
              >
                hop on a call with us.
              </a>
            </div>
          </div>
        </div>
      );
    } if (currentPage === 'questions') {
      return (
        <SearchProjectCreation
          consultant={consultant}
          project={project}
          backToProjectSelection={() => this.setCurrentPageToInvite()}
          handleInvited={(resourceId) => this.handleInvited(resourceId)}
          workLocationOptions={workLocationOptions}
          durationOptions={durationOptions}
          timePerWeekOptions={timePerWeekOptions}
          csrfToken={csrfToken}
          query={query}
          filters={filters}
        />
      );
    } if (currentPage === 'invite') {
      return (
        <InviteConsultant
          consultant={consultant}
          projects={projects}
          project={project}
          defaultProjectId={fromProject}
          csrfToken={csrfToken}
          goToQuestions={() => this.setCurrentPageToQuestions()}
          handleInvited={(resourceId) => this.handleInvited(resourceId)}
          query={query}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <div className="employer-invites-consultant-to-project modal-dialog">
        <div className="modal-content" role="document">
          <div className="modal-body">
            {this.renderPage()}
          </div>
        </div>
      </div>
    );
  }
}

EmployerInvitesConsultantToProjectModal.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  workLocationOptions: PropTypes.shape({}).isRequired,
  durationOptions: PropTypes.oneOfType([PropTypes.shape({}),
    PropTypes.instanceOf([])]).isRequired,
  timePerWeekOptions: PropTypes.oneOfType([PropTypes.shape({}),
    PropTypes.instanceOf([])]).isRequired,
  query: PropTypes.number,
  fromProject: PropTypes.string,
  filters: PropTypes.shape({}),
  currentUser: PropTypes.shape({}),
};

EmployerInvitesConsultantToProjectModal.defaultProps = {
  query: null,
  fromProject: null,
  filters: {},
  currentUser: {},
};

export default EmployerInvitesConsultantToProjectModal;
